
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class MenuBar extends Vue {
  data () {
    return {
      open: true,
      overlay: false,
      fullheight: true,
      fullwidth: false,
      right: false
    }
  }
}
